import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { GitLabIcon } from './GitLabIcon';

export default createWebRegistration({
  authProviders: {
    gitlab: {
      icon: GitLabIcon,
      benefit: 'Required for GitLab repository access',
    },
  },
});
